import { render, staticRenderFns } from "./PingAnTrunkInsurance.vue?vue&type=template&id=466f9a88&scoped=true"
import script from "./PingAnTrunkInsurance.vue?vue&type=script&lang=js"
export * from "./PingAnTrunkInsurance.vue?vue&type=script&lang=js"
import style0 from "./PingAnTrunkInsurance.vue?vue&type=style&index=0&id=466f9a88&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "466f9a88",
  null
  
)

export default component.exports